// Copyright (c) 2018, Frappe Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

frappe.ui.form.LinkSelector = class LinkSelector {
	constructor(opts) {
		$.extend(this, opts);

		var me = this;
		if (this.doctype != "[Select]") {
			frappe.model.with_doctype(this.doctype, function () {
				me.make();
			});
		} else {
			this.make();
		}
	}

	make() {
		var me = this;

		this.start = 0;
		this.selected_index = -1;
		this.result_rows = [];

		this.dialog = new frappe.ui.Dialog({
			title: __("Select {0}", [this.doctype == "[Select]" ? __("value") : __(this.doctype)]),
			fields: [
				{
					fieldtype: "Data",
					fieldname: "txt",
					label: __("Beginning with"),
					description: __("You can use wildcard %"),
				},
				{
					fieldtype: "HTML",
					fieldname: "results",
				},
				{
					fieldtype: "Button",
					fieldname: "more",
					label: __("More"),
					click: () => {
						me.start += 20;
						me.search();
					},
				},
			],
			primary_action_label: __("Search"),
			primary_action: function () {
				me.start = 0;
				me.search();
			},
		});

		if (this.txt) this.dialog.fields_dict.txt.set_input(this.txt);

		const results_wrapper = this.dialog.fields_dict.results.$wrapper;
		results_wrapper.css({
			"max-height": "320px",
			"overflow-y": "auto",
			"margin-top": "10px",
		});

		const txt_input = this.dialog.get_input("txt");

		txt_input.on("keypress", function (e) {
			if (e.which === 13 && me.selected_index === -1) {
				me.start = 0;
				me.search();
			}
		});

		txt_input.on("keydown", function (e) {
			if (!me.result_rows.length) return;

			if (e.which === 40) {
				e.preventDefault();
				me.selected_index = Math.min(me.selected_index + 1, me.result_rows.length - 1);
				me.highlight_row(me.selected_index);
			}

			if (e.which === 38) {
				e.preventDefault();
				me.selected_index = Math.max(me.selected_index - 1, 0);
				me.highlight_row(me.selected_index);
			}

			if (e.which === 13 && me.selected_index >= 0) {
				e.preventDefault();
				me.result_rows[me.selected_index].find("a").trigger("click");
			}
		});

		this.dialog.show();
		this.search();
	}

	search() {
		var args = {
			txt: this.dialog.fields_dict.txt.get_value(),
			searchfield: "name",
			start: this.start,
		};

		var me = this;

		if (this.target.set_custom_query) {
			this.target.set_custom_query(args);
		}

		if (
			this.target.is_grid &&
			this.target.fieldinfo[this.fieldname] &&
			this.target.fieldinfo[this.fieldname].get_query
		) {
			$.extend(args, this.target.fieldinfo[this.fieldname].get_query(cur_frm.doc));
		}

		frappe.link_search(
			this.doctype,
			args,
			function (r) {
				var parent = me.dialog.fields_dict.results.$wrapper;

				if (args.start === 0) {
					parent.empty();
					me.result_rows = [];
					me.selected_index = -1;
				}

				if (r.values.length) {
					$.each(r.values, function (i, v) {
						var row = $(
							repl(
								'<div class="row link-select-row">\
									<div class="col-xs-4">\
										<b><a href="#">%(name)s</a></b>\
									</div>\
									<div class="col-xs-8">\
										<span class="text-muted">%(values)s</span>\
									</div>\
								</div>',
								{
									name: v[0],
									values: v.slice(1).join(", "),
								}
							)
						).appendTo(parent);

						me.result_rows.push(row);

						row.find("a")
							.attr("data-value", v[0])
							.click(function () {
								var value = $(this).attr("data-value");

								if (me.target.is_grid) {
									me.set_in_grid(value).then(() => {
										me.dialog.fields_dict.txt.set_value("");
										me.search();
										me.dialog.get_input("txt").focus();
									});
								} else {
									if (me.target.doctype) {
										me.target.parse_validate_and_set_in_model(value);
									} else {
										me.target.set_input(value);
										me.target.$input.trigger("change");
									}
									me.dialog.fields_dict.txt.set_value("");
									me.search();
									me.dialog.get_input("txt").focus();
								}
								return false;
							});
					});
				} else {
					$(
						'<p><br><span class="text-muted">' +
							__("No Results") +
							"</span>" +
							(frappe.model.can_create(me.doctype)
								? '<br><br><a class="new-doc btn btn-default btn-sm">' +
								  __("Create a new {0}", [__(me.doctype)]) +
								  "</a>"
								: "") +
							"</p>"
					)
						.appendTo(parent)
						.find(".new-doc")
						.click(function () {
							frappe.new_doc(me.doctype);
						});
				}

				var more_btn = me.dialog.fields_dict.more.$wrapper;
				if (r.values.length < 20) {
					more_btn.hide();
				} else {
					more_btn.show();
				}
			},
			this.dialog.get_primary_btn()
		);
	}

	highlight_row(index) {
		this.result_rows.forEach((r) => r.removeClass("active"));
		if (this.result_rows[index]) {
			this.result_rows[index].addClass("active");
			this.result_rows[index][0].scrollIntoView({ block: "nearest" });
		}
	}

	set_in_grid(value) {
		return new Promise((resolve) => {
			if (this.qty_fieldname) {
				frappe.prompt(
					{
						fieldname: "qty",
						fieldtype: "Float",
						label: "Qty",
						default: 1,
						reqd: 1,
					},
					(data) => {
						let updated = (this.target.frm.doc[this.target.df.fieldname] || []).some(
							(d) => {
								if (d[this.fieldname] === value) {
									frappe.model
										.set_value(d.doctype, d.name, this.qty_fieldname, data.qty)
										.then(resolve);
									return true;
								}
							}
						);

						if (!updated) {
							let d = null;
							frappe.run_serially([
								() => (d = this.target.add_new_row()),
								() => frappe.timeout(0.1),
								() => {
									let args = {};
									args[this.fieldname] = value;
									args[this.qty_fieldname] = data.qty;
									return frappe.model.set_value(d.doctype, d.name, args);
								},
								resolve,
							]);
						}
					},
					__("Set Quantity"),
					__("Set Quantity")
				);
			} else if (this.dynamic_link_field) {
				let d = this.target.add_new_row();
				frappe.model
					.set_value(d.doctype, d.name, this.dynamic_link_field, this.dynamic_link_reference)
					.then(() =>
						frappe.model.set_value(d.doctype, d.name, this.fieldname, value)
					)
					.then(resolve);
			} else {
				let d = this.target.add_new_row();
				frappe.model.set_value(d.doctype, d.name, this.fieldname, value).then(resolve);
			}
		});
	}
};

frappe.link_search = function (doctype, args, callback, btn) {
	if (!args) args = { txt: "" };
	args.doctype = doctype;
	if (!args.searchfield) args.searchfield = "name";

	frappe.call({
		method: "frappe.desk.search.search_widget",
		type: "GET",
		args: args,
		callback: function (r) {
			callback && callback(r);
		},
		btn: btn,
	});
};